import React, { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

import { CallPopup } from 'components';
import graph from './graph';
import Mapir from './Mapir';
import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';
import { CountdownTimer } from 'components';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
// import RefundProductToWallet from './RefundProductToWallet';
import './print.css';

import { addCommas, digitsEnToFa } from '@persian-tools/persian-tools';
import {
  Box,
  Popover,
  Card,
  Stack,
  Avatar,
  CardHeader,
  Typography,
  IconButton,
  CardMedia,
  CardContent,
  Button,
  Tooltip,
  CardActions,
} from '@mui/material';
import { CircularProgress } from '@mui/material';

export default function Content({ model }) {
  const {
    id,
    call_me,
    fast_send,
    total_cost,
    created_at,
    demand_time,
    delivery_time,
    tracking_code,
    shop,
    status,
    customer,
    tracks,
  } = model;
  const [result, setResult] = useState();
  const { userToken } = useSelector((state) => state.auth);

  const [getData, { loading }] = useLazyQuery(graph.get.query, {
    variables: {
      ids: id,
      for_admin: 1,
    },
    context: {
      serviceName: graph.get.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const fetchData = async () => {
    try {
      const { data } = await getData();
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name]?.data[0];
        setResult(res);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <Stack justifyContent="center" alignItems="center" height="100%" rowGap={2}>
        <CircularProgress size={26} />
        <Typography variant="caption">در حال بارگذاری...</Typography>
      </Stack>
    );
  }

  if (result) {
    const { address, carrier, created_at, demand_time, delivery_time, shipping, tracks } = result;
    const carrierUser = carrier?.user;
    const img =
      carrierUser?.media && carrierUser?.media[0] ? carrierUser.media[0]?.full_url : '/assets/images/picture.png';
    return (
      <Stack justifyContent="space-between" height="100%" rowGap={1}>
        <Stack rowGap={1} pt={2}>
          <Card>
            <CardHeader
              avatar={<Avatar alt="carrier" src={img} />}
              title={carrierUser ? `${carrierUser.firstname} ${carrierUser.lastname}` : shipping?.type.title}
              subheader={`وضعیت سفارش: ${status?.title}`}
              action={
                <Stack direction="row" justifyContent="flex-end" alignItems="center" columnGap={0.5} flex={1}>
                  {carrierUser?.cellphone && (
                    <Stack className="no-print">
                      <CallPopup title="تماس با حمل کننده" phone={carrierUser?.cellphone} />
                    </Stack>
                  )}
                  {fast_send === 1 && (
                    <Stack
                      borderRadius={1}
                      px={1}
                      width={48}
                      height={42}
                      overflow="hidden"
                      justifyContent="space-between"
                      alignItems="center"
                      direction="row"
                      position="relative"
                      sx={{
                        bgcolor: 'info.lighter',
                        transition: 'all 0.5s ease-in',
                        ':hover': { width: 120, transition: 'all 0.3s ease-out' },
                      }}
                    >
                      <Typography variant="subtitle2" fontSize={14} noWrap>
                        ارسال سریع
                      </Typography>
                      <RocketLaunchRoundedIcon sx={{ width: 32 }} fontSize="small" color="info" />
                    </Stack>
                  )}
                </Stack>
              }
            />
            <CardContent>
              <Stack direction="row">
                <Stack flex={1} rowGap={2} justifyContent="center" alignItems="center">
                  <Typography variant="subtitle2" color="text.secondary">
                    {address?.main_street}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="text.disabled"
                  >{`آدرس کامل: ${address?.minor_address}`}</Typography>

                  <Stack minWidth={300} direction="row" justifyContent="space-between">
                    <Typography variant="subtitle2" color="text.disabled">
                      کد پستی
                    </Typography>
                    <Typography textAlign="center" variant="subtitle1" letterSpacing={3}>
                      {address?.postal_code || '-'}
                    </Typography>
                  </Stack>
                  <CallPopup title="تماس با تحویل گیرنده" phone={address?.tellphone} />
                </Stack>
                <Stack flex={1}>
                  <Mapir
                    init={[address?.lng, address?.lat]}
                    shipping={[tracks[0]?.lng, tracks[0]?.lat]}
                  />
                </Stack>
              </Stack>
            </CardContent>
            {delivery_time && (
              <CardActions sx={{ px: 2, alignItems: 'center', justifyContent: 'space-between' }}>
                <Stack rowGap={1}>
                  <Typography variant="subtitle2" color="primary.dark">
                    سفارش با موفقیت تحویل داده شد!
                  </Typography>
                  <Stack direction="row" columnGap={4}>
                    <DeliveryDate
                      title="تاریخ تحویل"
                      date={delivery_time}
                      color="success.darker"
                      bgcolor="success.lighter"
                    />
                    <DeliveryDate title="تاریخ درخواست" date={demand_time} />
                  </Stack>
                </Stack>
                {result?.media && (
                  <Stack direction="row" alignItems="center">
                    <Typography variant="subtitle2" color="text.disabled" fontSize={14}>
                      امضا تحویل گیرنده
                    </Typography>
                    <ModelAvatar media={result?.media} />
                  </Stack>
                )}
              </CardActions>
            )}
          </Card>
        </Stack>
      </Stack>
    );
  }
}

const ModelAvatar = ({ media }) => {
  const img = media && media[0] ? media[0]?.full_url : '/assets/images/picture.png';
  return <Avatar src={img} variant="rounded" sx={{ width: 140, height: 140, p: 1 }} />;
};

const DeliveryDate = ({ title, date, color = 'warning.darker', bgcolor = 'warning.lighter' }) =>
  date && (
    <Stack direction="row" columnGap={1} alignItems="center">
      <Typography width={80} variant="subtitle1" fontSize={12}>
        {title}
      </Typography>
      <CountdownTimer targetDate={date} color={color} bgcolor={bgcolor} />
    </Stack>
  );
